import { useDroppable } from '@dnd-kit/core';
import {
  DirectionalDroppableType,
  ISortableWidgetData,
  Widget,
} from '@framework/engine';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { sortingStrategyDirection } from '../utils/sortingStrategyDirection';
import { InsertPositionIndicator } from './InsertPositionIndicator';

const ContainerExtraDroppableWrapper = styled.div`
  /* background-color: #ffd6d6; */
  pointer-events: none;
  position: absolute;
  z-index: 9;
  height: 20px;
  width: 100%;
  // spostiamo l'area di drop in parte fuori dal container
  &.after-area {
    bottom: -9px;
  }
  &.before-area {
    top: -15px;
  }
  // Quando il container è una riga (direzione orizzontale),
  // l'area di drop è posizionata ai lati del container
  &.horizontal {
    height: 100%;
    width: 20px;
    &.after-area {
      right: 0;
      top: 0;
      bottom: 0;
    }
    &.before-area {
      left: 0;
      top: 0;
      bottom: 0;
    }
  }
`;

interface IContainerExtraDroppableProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  type: DirectionalDroppableType;
  widget: Widget;
  parent?: Widget;
}

/**
 * Componente per la gestione delle aree di drop utilizzate per il repositioning dei container.
 * Attraverso il DnD, se l'area viene raggiunta, viene considerato come un tentativo di riposizionamento
 * dell'active _al posto_ del container anziché un tentativo di inserimento _nel_ container.
 */
export function ContainerExtraDroppable(props: IContainerExtraDroppableProps) {
  const { widget, parent, type } = props;

  const sortableData: ISortableWidgetData = {
    path: widget.path,
    order: widget.order,
    type: widget.type,
    directionalDroppableType: type,
    originalId: widget.id,
  };

  const droppableId = `${type}-${widget.id}`;

  const { setNodeRef, isOver } = useDroppable({
    id: droppableId,
    data: sortableData,
  });

  return (
    <>
      <ContainerExtraDroppableWrapper
        ref={setNodeRef}
        className={clx(`${type}-area`, `${sortingStrategyDirection(parent)}`, {
          'is-hover-me': isOver,
        })}
      />
      <InsertPositionIndicator
        showIndicator={isOver}
        parent={parent}
        type={type}
      />
    </>
  );
}
